import { RetailUnitSchema } from '@lotta/shared/types-lottery-schemas';
import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type GetAllRetailUnitsParams = Static<typeof GetAllRetailUnitsParamsSchema>;
export const GetAllRetailUnitsParamsSchema = Type.Object(
  {},
  { additionalProperties: false, $id: 'GetRetailUnitResponseSchema' }
);

export type GetAllRetailUnitsResponse = Static<typeof GetAllRetailUnitsResponseSchema>;
export const GetAllRetailUnitsResponseSchema = Type.Object(
  {
    retailUnits: Type.Array(RetailUnitSchema),
  },
  { additionalProperties: false, $id: 'GetRetailUnitResponseSchema' }
);
